import { MoreVert } from '@mui/icons-material';
import {
  IconButton,
  TableCell,
  TableRow
} from '@mui/material';
import { DateTime } from 'luxon';
import {
  DocumentMenu,
  menuUtil
} from 'modules';
import React from 'react';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';



export type DocumentTableRowProps = {
  id: string;
  fileName: string;
  size: string;
  updatedDate: DateTime;
  createdDate: DateTime;
  uploadedBy: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DocumentTableRowProps) => {
  const {
    anchorEl,
    handleClick,
    handleClose,
    open
  } = menuUtil.useBaseMenuState();

  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    if (path.endsWith('files')) {
      navigate(`${props.id}`);
    } else if (path.includes('folders')) {
      navigate(`../../files/${props.id}`);
    }
  };

  return (
    <TableRow
      content='list'
      onClick={(e) => {
        e.stopPropagation();
        handleNavigate(location.pathname);
      }}
    >
      <TableCell
        variant='firstRounded'
      >
        {props.fileName}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.size}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.createdDate.toFormat('DDDD')}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.updatedDate.toFormat('DDDD')}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.uploadedBy}
      </TableCell>
      <TableCell
        variant='lastRounded'
      >
        <IconButton
          onClick={(e) => handleClick(e)}
        >
          <MoreVert />
        </IconButton>
        {open && (
          <DocumentMenu.FC
            open={open}
            anchorEl={anchorEl ?? null}
            handleClick={handleClick}
            handleClose={handleClose}
            id={props.id}
          />
        )}

      </TableCell>

    </TableRow>

  );
};
